module.exports = __webpack_public_path__ + "static/media/snow.9a42d992.png";